import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { AddMaterialBookClubComponent } from '../add-material-book-club/add-material-book-club.component';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { DeleteComponent } from 'src/app/components/delete/delete.component';

@Component({
  selector: 'app-material-book-club',
  templateUrl: './material-book-club.component.html',
  styleUrls: ['./material-book-club.component.scss']
})
export class MaterialBookClubComponent implements OnInit {
  tabs = TESTING_CENTER.BOOK_CLUB_MATERIAL;

  ITEM: any;

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private dialog: MatDialog
    , public test: PlacementTest
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
    , public store: BookstoreStore
  ) { }

  goBack() {
    this.router.navigate([`/book-club`])
  }

  ngOnInit() {
    this.route.params.subscribe(async params => {
      const { id } = params
      this.tabs = TESTING_CENTER.BOOK_CLUB_MATERIAL.map(m => ({ path: `${m.path}/${id}`, label: m.label }))
      this.ITEM = await this.test.fetchClassTesting(id);
      if (!this.ITEM) {
        this.router.navigate([`/404`]);
        return;
      }
      this.store.fetchReading(id)
    })
  }

  addItem() {
    let dialogRef = this.dialog.open(AddMaterialBookClubComponent, {
      data: { READING: null, CLASS_KEY: this.ITEM.key },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }


  delete(reading) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'Remove', name: reading.name.name, title: 'Remove Reading' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.delete(reading, (success, res) => {
          this.snackBar.open("Reading has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }


}
